var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [_c("span", [_vm._v("パスワード変更")])]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text item" },
      [
        _vm.errors.loginError
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.errors.loginError))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-form",
          { ref: "form", attrs: { model: _vm.form, "label-width": "190px" } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "現在のパスワード",
                  error: _vm.errors.currentPasswordError
                }
              },
              [
                _c("el-input", {
                  attrs: { "show-password": "" },
                  model: {
                    value: _vm.form.currentPassword,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "currentPassword", $$v)
                    },
                    expression: "form.currentPassword"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "新しいパスワード",
                  error: _vm.errors.newPasswordError
                }
              },
              [
                _c("el-input", {
                  attrs: { "show-password": "" },
                  model: {
                    value: _vm.form.newPassword,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "newPassword", $$v)
                    },
                    expression: "form.newPassword"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "新しいパスワード(確認用)",
                  error: _vm.errors.confirmPasswordError
                }
              },
              [
                _c("el-input", {
                  attrs: { "show-password": "" },
                  model: {
                    value: _vm.form.confirmPassword,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "confirmPassword", $$v)
                    },
                    expression: "form.confirmPassword"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                  [_vm._v("変更")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.backTop } }, [
                  _vm._v("戻る")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }